module.exports = __webpack_public_path__ + "img/notizen.9fb5e3cc.png";